export type RoleClass =
  | 'owner'
  | 'admin'
  | 'developer'
  | 'client_admin'
  | 'client_user'
  | 'readonly_viewer'
  | 'local_orchestrator'
  | 'edge_bff'
  | 'worker_service'
  | 'external_agent';

const ROLE_ALIASES: Record<string, RoleClass> = {
  'tenant.owner': 'owner',
  'tenant.admin': 'admin',
  'tenant.developer': 'developer',
  'tenant.client_admin': 'client_admin',
  'tenant.client_user': 'client_user',
  'tenant.readonly_viewer': 'readonly_viewer',
  owner: 'owner',
  admin: 'admin',
  developer: 'developer',
  client_admin: 'client_admin',
  client_user: 'client_user',
  user: 'client_user',
  viewer: 'readonly_viewer',
  readonly_viewer: 'readonly_viewer',
};

export const OPERATOR_ROLE_CLASSES: ReadonlySet<RoleClass> = new Set(['owner', 'admin', 'developer']);
export const CLIENT_WRITE_ROLE_CLASSES: ReadonlySet<RoleClass> = new Set(['owner', 'admin', 'client_admin', 'client_user']);

export function resolveRoleClass(roles: string[]): RoleClass {
  for (const role of roles.map((value) => value.toLowerCase())) {
    const mapped = ROLE_ALIASES[role];
    if (mapped) return mapped;
  }
  return 'readonly_viewer';
}

export function canRequestTenantChange(roleClass: RoleClass): boolean {
  return CLIENT_WRITE_ROLE_CLASSES.has(roleClass);
}

export function canOpenDevHub(roleClass: RoleClass): boolean {
  return OPERATOR_ROLE_CLASSES.has(roleClass);
}
